/** Pure helpers of the Items ▸ Stock Qty Edit popup (the rules live in the API; these only shape the UI). */

export const MAX_ADDITIONAL_QTY = 10000;

// G5 wording (Model.xafml LocalizationItems) — the API sends the same texts on a refusal.
export const MSG_SELECT_AN_ITEM = 'Please select an item to proceed further.';
export const MSG_ITEMS_NOT_ADDED = 'Items not added.';
export const MSG_QTY_OUT_OF_RANGE = `Additional Qty must be between 0 and ${MAX_ADDITIONAL_QTY}.`;
export const MSG_PRESS_ADD_AGAIN = 'Additional Qty changed after ADD. Press ADD again.';

/** A row of the popup's upper grid (the API's StockQtyItemRow). */
export type ItemRow = {
  id: string;
  itemCode: string;
  item: string;
  stockQty: number;
  additionalQty: number;
  specification: string;
  vendor: string;
  isVendorLT: boolean;
};

/** A drafted container as the API returns it. */
export type ServerDraftRow = {
  itemId: string;
  itemCode: string;
  item: string;
  vendor: string;
  isVendorLT: boolean;
  lt: string;
};

/** A drafted container in the "Stock Added" grid, with what the lab has typed into it so far. */
export type DraftRow = ServerDraftRow & {
  key: string;
  vendorLT: string;
  /** The grid's date editor wire value (YYYY-MM-DDTHH:mm:ss) — empty until picked. */
  expiry: string;
  /** The Storage NAME (the combo offers names); the id is looked up on save. */
  storage: string;
};

/** A typed Additional Qty: a whole number 0…10000, else null (G5 RuleRange). */
export function parseAdditionalQty(text: string): number | null {
  const t = text.trim();
  if (!/^\d+$/.test(t)) return null;
  const n = Number.parseInt(t, 10);
  return n <= MAX_ADDITIONAL_QTY ? n : null;
}

export function toDraftRows(rows: ServerDraftRow[]): DraftRow[] {
  return rows.map((r) => ({ ...r, key: `${r.itemId}|${r.lt}`, vendorLT: '', expiry: '', storage: '' }));
}

/** Order-independent fingerprint of "these items with these quantities" — ADD on the same set again is a
 *  no-op in G5 ("Items are already added."). Items with nothing to add do not count. */
export function draftSignature(items: { id: string; additionalQty: number }[]): string {
  return items
    .filter((i) => i.additionalQty > 0)
    .map((i) => `${i.id}:${i.additionalQty}`)
    .sort()
    .join('|');
}
